import React, { useRef } from 'react';
import cn from 'bem-cn';

import { ScreenSize, useGetScreenSize, useIsHydrated } from '../../hooks';
import { WelcomeSection } from '../../components/WelcomeSection';
import { TelegramBanner } from '../../components/TelegramBanner';
import { HomePageSearch } from '../../components/HomePageSearch';
import { CategorySelector } from '../../components/CategorySelector';
import { Feed, useInfiniteFeed } from '../../components/Feed';

import { usePromptFeedColumns, useSelectedCategoriesFromUrl } from './HomePage.hooks';
import './HomePage.scss';

const b = cn('home-page');

export const HomePage: React.FC = React.memo(() => {
    const catalogTitleRef = useRef<HTMLDivElement>(null);

    const isLoaded = useIsHydrated();

    const columns = usePromptFeedColumns();
    const screenSize = useGetScreenSize();
    const isTouch = screenSize <= ScreenSize.Tablet;

    // Используем хук с двусторонней синхронизацией URL ↔ состояние
    const { selectedCategories, updateSelectedCategories } = useSelectedCategoriesFromUrl();

    const {
        prompts,
        challenges,
        courses,
        loading: isLoading,
        hasMore,
    } = useInfiniteFeed({
        categories: selectedCategories,
        pageSize: 30,
        threshold: 600,
    });

    return (
        <div className={b()}>
            <WelcomeSection />
            <div className={b('content')}>
                <TelegramBanner />
                <div className={b('title')} ref={catalogTitleRef}>
                    Каталог промптов
                </div>
                <HomePageSearch />
                <div className={b('categories', { loaded: isLoaded })}>
                    <CategorySelector
                        selectedCategories={selectedCategories}
                        onChangeCategories={updateSelectedCategories}
                        size={isTouch ? 'normal' : 'large'}
                        scrollToElementOnMenuOpen={catalogTitleRef}
                        centered
                    />
                </div>
                <Feed
                    containerClassName="home-page__feed"
                    prompts={prompts}
                    courses={courses}
                    challenges={challenges}
                    columns={columns}
                    isLoading={isLoading}
                    hasMore={hasMore}
                    needMarkPromptsAsViewed
                />
            </div>
        </div>
    );
});

HomePage.displayName = 'HomePage';
